export default __webpack_public_path__ + "static/media/moc.9eb96f9a.png";